<template>
  <div>
    <!-- Start App Main Banner -->
    <div class="main-banner app-home">
      <div class="d-table">
        <div class="d-table-cell">
          <div class="container">
            <div class="row">
              <div class="col-lg-6 col-md-12">
                <div class="hero-content">
                  <h1>اذكاري - طمئن قلبك بذكر الله</h1>
                  <p> تطبيق أذكاري يحتوي كل ما يحتاجه المسلم يوميا : اذكار الصباح , اذكار المساء , قرآن ,حديث , أدعية و
                    المزيد .. </p>
                  <section class="app-download">
                    <div class="row h-100">
                      <div class="col-lg-12 col-md-12">
                        <div class="section-title">
                          <h2 style="color: white;">حمل تطبيق أذكاري الان</h2>
                          <div class="bar"></div>
                          <div class="download-btn">
                            <a href="https://bit.ly/2Yh5hHn" target="_blank">
                              <i class="icofont-brand-android-robot"></i> متوفر على <span>جوجل اندرويد</span>
                            </a>
                            <a href="https://apple.co/34Rcosr" target="_blank">
                              <i class="icofont-brand-apple"></i> متوفر على <span>ايفون و ايباد</span>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                  <!-- <form><input type="email" placeholder="Enter your email...." class="form-control"><button type="submit" class="btn btn-primary">Begin Free Trial</button></form> -->
                </div>
              </div>
              <div class="col-lg-6 col-md-12">
                <div class="app-image">
                  <img :src="`${publicPath}assets/img/frame1.png`" alt="image">
                  <img :src="`${publicPath}assets/img/frame2.png`" alt="image">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="creative-shape">
        <img :src="`${publicPath}assets/img/bg3.png`" alt="bg">
      </div>
      <div class="bg-gray shape-1"></div>
      <div class="shape1">
        <img :src="`${publicPath}assets/img/shape1.png`" alt="img">
      </div>
      <div class="shape2">
        <img :src="`${publicPath}assets/img/shape2.png`" alt="img">
      </div>
      <div class="shape3">
        <img :src="`${publicPath}assets/img/shape3.png`" alt="img">
      </div>
      <div class="shape4 rotateme">
        <img :src="`${publicPath}assets/img/shape4.png`" alt="img">
      </div>
      <div class="shape6">
        <img :src="`${publicPath}assets/img/shape6.png`" alt="img">
      </div>
      <div class="shape8 rotateme">
        <img :src="`${publicPath}assets/img/shape8.svg`" alt="shape">
      </div>
      <div class="shape9">
        <img :src="`${publicPath}assets/img/shape9.svg`" alt="shape">
      </div>
    </div>
    <!-- End App Main Banner -->
    <!-- Start Partner Area -->
    <!-- <div class="partner-area app-partner"><div class="container"><div class="row"><div class="partner-slides"><div class="col-lg-12"><div class="item"><a href="#"><img :src="`${publicPath}assets/img/partner-1.png" alt="partner"></a></div></div><div class="col-lg-12"><div class="item"><a href="#"><img :src="`${publicPath}assets/img/partner-2.png" alt="partner"></a></div></div><div class="col-lg-12"><div class="item"><a href="#"><img :src="`${publicPath}assets/img/partner-3.png" alt="partner"></a></div></div><div class="col-lg-12"><div class="item"><a href="#"><img :src="`${publicPath}assets/img/partner-4.png" alt="partner"></a></div></div><div class="col-lg-12"><div class="item"><a href="#"><img :src="`${publicPath}assets/img/partner-5.png" alt="partner"></a></div></div><div class="col-lg-12"><div class="item"><a href="#"><img :src="`${publicPath}assets/img/partner-6.png" alt="partner"></a></div></div><div class="col-lg-12"><div class="item"><a href="#"><img :src="`${publicPath}assets/img/partner-7.png" alt="partner"></a></div></div></div></div></div></div> -->
    <!-- End Partner Area -->
    <!-- Start Features Area -->
    <section class="features-area app-features ptb-100">
      <div class="container">
        <div class="section-title">
          <h2> خصائص التطبيق </h2>
          <div class="bar"></div>
          <p> صُمم ليساعدك على ان لا تنسى ذكر الله ابداً، وعلى طريقتك الخاص </p>
        </div>
        <div class="row">
          <div class="col-lg-4 col-md-6">
            <div class="single-features-box">
              <div class="icon">
                <i class="icofont-sun"></i>
              </div>
              <h3>أذكار الصباح والمساء</h3>
              <p> يذكرك بأذكار الصباح والمساء والنوم في الوقت الذي تريده. و يسهل عليك قراءة الاذكار لتتمكن من جعل الذكر
                عادة.</p>
            </div>
          </div>
          <div class="col-lg-4 col-md-6">
            <div class="single-features-box">
              <div class="icon">
                <i class="icofont-notification"></i>
              </div>
              <h3>اشعار أذكاري</h3>
              <p> هو اشعار سيظهر على الشاشة لثوان معدودة, فيه ذكر او حديث او اية و سيختفي عند قرائته او النقر عليه.
                ويمكنك تصميم شكله على مزاجك. </p>
            </div>
          </div>
          <div class="col-lg-4 col-md-6 offset-lg-0 offset-md-3">
            <div class="single-features-box">
              <div class="icon">
                <i class="icofont-hand"></i>
              </div>
              <h3> أدعو معي </h3>
              <p> صممت هذه الصفحة ليتمكن اخواننا مستخدمي التطبيق من مشاركة ادعيتهم المفضلة مع باقي المستخدمين و يمكن
                التفاعل مع الدعاء بزر امين. </p>
            </div>
          </div>
        </div>
      </div>
      <div class="features-inner-area">
        <div class="container-fluid">
          <div class="row h-100 justify-content-center align-items-center">
            <div class="col-lg-6 col-md-12">
              <div class="features-image">
                <img :src="`${publicPath}assets/img/features-img1.png`" alt="image">
              </div>
            </div>
            <div class="col-lg-6 col-md-12">
              <div class="features-inner-content">
                <div class="features-item">
                  <div class="icon">
                    <i class="icofont-ui-laoding"></i>
                  </div>
                  <h3> المسبحة الاكترونية الذكية </h3>
                  <p> ستتذكر عنك اين كنت بالورد اليومي </p>
                </div>
                <div class="features-item">
                  <div class="icon">
                    <i class="icofont-ui-text-chat"></i>
                  </div>
                  <h3> رسائل أذكاري </h3>
                  <p> تطبيق أذكاري يحتوي على صفحة رسائل اذكاري لتلقي اذكار و ادعية و احاديث و ايات قرانية بشكل يومي وذلك
                    حسب المناسبة او الوقت. </p>
                </div>
                <div class="features-item">
                  <div class="icon">
                    <i class="icofont-ui-volume"></i>
                  </div>
                  <h3> نسمع اقتراحاتكم </h3>
                  <p> تم صنع التطبيق ليناسب احتياجاتكم. و تم تطويره بناء على اقتراحاتكم. </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="shape7">
        <img :src="`${publicPath}assets/img/shape7.png`" alt="shape">
      </div>
      <div class="shape3">
        <img :src="`${publicPath}assets/img/shape3.png`" alt="img">
      </div>
      <div class="bg-gray shape-1"></div>
      <div class="shape6">
        <img :src="`${publicPath}assets/img/shape6.png`" alt="img">
      </div>
      <div class="shape8 rotateme">
        <img :src="`${publicPath}assets/img/shape8.svg`" alt="shape">
      </div>
      <div class="shape9">
        <img :src="`${publicPath}assets/img/shape9.svg`" alt="shape">
      </div>
      <div class="shape10">
        <img :src="`${publicPath}assets/img/shape10.svg`" alt="shape">
      </div>
      <div class="shape11 rotateme">
        <img :src="`${publicPath}assets/img/shape11.svg`" alt="shape">
      </div>
    </section>
    <!-- End Features Area -->
    <!-- Start How App Work -->
    <!-- <section class="how-app-work ptb-100"><div class="container"><div class="section-title"><h2>How App Works</h2><div class="bar"></div><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p></div><div class="row"><div class="col-lg-12 col-md-12"><div class="app-mobile"><img :src="`${publicPath}assets/img/app-mobile.png" alt="mobile"></div></div><div class="col-lg-4 col-md-6"><div class="single-app-works"><div class="icon"><i class="icofont-downloaded"></i></div><h3>Download</h3><p>Duis cursus dictum enim dictum venenatis. Orci varius natoque penatibus et magnis dis parturient montes.</p></div></div><div class="col-lg-4 col-md-6"><div class="single-app-works"><div class="icon"><i class="icofont-settings"></i></div><h3>Setup It</h3><p>Duis cursus dictum enim dictum venenatis. Orci varius natoque penatibus et magnis dis parturient montes.</p></div></div><div class="col-lg-4 col-md-6 offset-lg-0 offset-md-3"><div class="single-app-works"><div class="icon"><i class="icofont-thumbs-up"></i></div><h3>Enjoy it</h3><p>Duis cursus dictum enim dictum venenatis. Orci varius natoque penatibus et magnis dis parturient montes.</p></div></div></div></div></section> -->
    <!-- End How App Work -->
    <!-- Start Overview Area -->
    <section class="overview-section ptb-100">
      <div class="container">
        <div class="section-title">
          <h2> المزيد لتكتشفه </h2>
          <div class="bar"></div>
          <p> بعض الميزات الاخرى التي ستكتشها في التطبيق: </p>
        </div>
        <div class="overview-box">
          <div class="row h-100 justify-content-center align-items-center">
            <div class="col-lg-6 col-md-6 overview-img">
              <img :src="`${publicPath}assets/img/frame3_qibla.png`" alt="image">
            </div>
            <div class="col-lg-6 col-md-6 overview-content">
              <div class="icon">
                <i class="icofont-compass-alt"></i>
              </div>
              <h3> بوصلة القبلة </h3>
              <p> باستخدام خدمة تحديد الموقع ستتمكن من معرفة اتجاه القبلة </p>
              <ul>
                <li>تعمل بدون انترنت</li>
                <li>تستخدم خدمة الموقع فقط عند الحاجة</li>
              </ul>
              <!-- <a href="#" class="btn btn-primary">Read More</a> -->
            </div>
          </div>
        </div>
        <div class="overview-box">
          <div class="row h-100 justify-content-center align-items-center">
            <div class="col-lg-6 col-md-6 overview-content">
              <div class="icon">
                <i class="icofont-expressionless"></i>
              </div>
              <h3> صفحة كيف تشعر؟ </h3>
              <p></p>
              <ul>
                <li>الأذكار مرتبة حسب الشعور</li>
                <li>الفرح , الحزن, الضعف, و غيرها من التصنيفات</li>
                <li>التطبيق الوحيد الذي يحتوي على هذه الميزة</li>
              </ul>
              <!-- <a href="#" class="btn btn-primary">Read More</a> -->
              <p></p>
            </div>
            <div class="col-lg-6 col-md-6 app-fetured-item">
              <div class="app-item item-one">
                <i class="icofont-crying"></i>
                <h6>الحزن</h6>
              </div>
              <div class="app-item item-two">
                <i class="icofont-worried"></i>
                <h6>القلق</h6>
              </div>
              <div class="app-item item-three">
                <i class="icofont-wink-smile"></i>
                <h6>الفرح</h6>
              </div>
              <div class="app-item item-four">
                <i class="icofont-heart-eyes"></i>
                <h6>الحب</h6>
              </div>
            </div>
          </div>
        </div>
        <div class="overview-box">
          <div class="row h-100 justify-content-center align-items-center">
            <div class="col-lg-6 col-md-6 overview-img">
              <img :src="`${publicPath}assets/img/frame5_halka.png`" alt="image">
            </div>
            <div class="col-lg-6 col-md-6 overview-content">
              <div class="icon">
                <i class="icofont-users-social"></i>
                <!-- icofont-ui-messaging -->
              </div>
              <h3>حلقة الذكر</h3>
              <p> التطبيق الاول الذي يحتوي على ميزة حلقات الذكر </p>
              <ul>
                <li> يمكنك معرفة عدد المستخدمين الذين في نفس الحلقة</li>
                <li> يزداد عداد الذكر بشكل فوري</li>
                <li> تستخدم الانترنت لكن طورت بعناية بحيث تستهلك شيء لا يذكر من باقة هاتفك</li>
              </ul>
              <!-- <a href="#" class="btn btn-primary">Read More</a> -->
              <p></p>
            </div>
          </div>
        </div>
        <div class="overview-box">
          <div class="row h-100 justify-content-center align-items-center">
            <div class="col-lg-6 col-md-6 overview-content">
              <div class="icon">
                <i class="icofont-book-mark"></i>
              </div>
              <h3>القرآن الكريم</h3>
              <p> - </p>
              <ul>
                <li>القرآن الكريم كاملا</li>
                <li>يعمل بدون الاتصال بالانترنت</li>
                <li>يمكنك حفظ الايات التي تريد في المفضلة</li>
              </ul>
              <!-- <a href="#" class="btn btn-primary">Read More</a> -->
            </div>
            <div class="col-lg-6 col-md-6 overview-img">
              <img :src="`${publicPath}assets/img/frame4_quraan.png`" alt="image">
            </div>
          </div>
        </div>
        <!-- <div class="overview-box modern-flexible"><div class="row h-100 justify-content-center align-items-center"><div class="col-lg-4 col-md-6"><div class="single-item right-icon"><div class="icon"><i class="icofont-lamp-light"></i></div><h3>Stunning Showcases</h3><p>Nam fermentum, arcu nec porta aliquam, lacus lorem efficitur lectus, quis sagittis tellus erat quis.</p></div><div class="single-item right-icon"><div class="icon"><i class="icofont-responsive"></i></div><h3>Fully Customizable</h3><p>Nam fermentum, arcu nec porta aliquam, lacus lorem efficitur lectus, quis sagittis tellus erat quis.</p></div><div class="single-item right-icon"><div class="icon"><i class="icofont-ui-timer"></i></div><h3>Engaging Tours</h3><p>Nam fermentum, arcu nec porta aliquam, lacus lorem efficitur lectus, quis sagittis tellus erat quis.</p></div></div><div class="col-lg-4 col-md-12 overview-img"><img :src="`${publicPath}assets/img/feature-img-with-app.png" alt="image"></div><div class="col-lg-4 col-md-6"><div class="single-item"><div class="icon"><i class="icofont-ui-timer"></i></div><h3>Engaging Tours</h3><p>Nam fermentum, arcu nec porta aliquam, lacus lorem efficitur lectus, quis sagittis tellus erat quis.</p></div><div class="single-item"><div class="icon"><i class="icofont-star-alt-2"></i></div><h3>Exquisite Design</h3><p>Nam fermentum, arcu nec porta aliquam, lacus lorem efficitur lectus, quis sagittis tellus erat quis.</p></div><div class="single-item"><div class="icon"><i class="icofont-ui-timer"></i></div><h3>Engaging Tours</h3><p>Nam fermentum, arcu nec porta aliquam, lacus lorem efficitur lectus, quis sagittis tellus erat quis.</p></div></div></div></div></div> -->
        <div class="shape7">
          <img :src="`${publicPath}assets/img/shape7.png`" alt="shape">
        </div>
        <div class="shape3">
          <img :src="`${publicPath}assets/img/shape3.png`" alt="img">
        </div>
        <div class="bg-gray shape-1"></div>
        <div class="shape6">
          <img :src="`${publicPath}assets/img/shape6.png`" alt="img">
        </div>
        <div class="shape8 rotateme">
          <img :src="`${publicPath}assets/img/shape8.svg`" alt="shape">
        </div>
        <div class="shape9">
          <img :src="`${publicPath}assets/img/shape9.svg`" alt="shape">
        </div>
        <div class="shape10">
          <img :src="`${publicPath}assets/img/shape10.svg`" alt="shape">
        </div>
        <div class="shape11 rotateme">
          <img :src="`${publicPath}assets/img/shape11.svg`" alt="shape">
        </div>
      </div>
    </section>
    <!-- End Overview Area -->
    <!-- Start App Funfacts Area -->
    <section class="app-funfacts-area ptb-100">
      <div class="container">
        <div class="row">
          <div class="col-lg-3 col-md-3">
            <div class="single-funfact">
              <div class="icon">
                <i class="icofont-download"></i>
              </div>
              <h3>
                <span class="count">3</span>M+
              </h3>
              <p>تحميل</p>
            </div>
          </div>
          <div class="col-lg-3 col-md-3">
            <div class="single-funfact">
              <div class="icon">
                <i class="icofont-star"></i>
              </div>
              <h3>
                <span class="count">4.8</span>
              </h3>
              <p>التقييم</p>
            </div>
          </div>
          <div class="col-lg-3 col-md-3">
            <div class="single-funfact">
              <div class="icon">
                <i class="icofont-user-suited"></i>
              </div>
              <h3>
                <span class="count">800</span>K+
              </h3>
              <p>مستخدم</p>
            </div>
          </div>
          <div class="col-lg-3 col-md-3">
            <div class="single-funfact">
              <div class="icon">
                <i class="icofont-thumbs-up"></i>
              </div>
              <h3>
                <span class="count">100</span>K+
              </h3>
              <p>تعليق</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End App Funfacts Area -->
    <!-- Start SAAS Tools Area -->
    <section class="saas-tools ptb-100 bg-gray">
      <div class="container">
        <div class="section-title">
          <h2> تطبيق اذكاري </h2>
          <div class="bar"></div>
          <p> طمئن قلبك بذكر الله </p>
        </div>
        <div class="row">
          <div class="col-lg-12 col-md-12">
            <div class="tab">
              <ul class="tabs">
                <li>
                  <a href="#">
                    <i class="icofont-copy-invert"></i>
                    <br> أذكاري </a>
                </li>
                <li>
                  <a href="#">
                    <i class="icofont-inbox"></i>
                    <br> رسائل أذكاري </a>
                </li>
                <li>
                  <a href="#">
                    <i class="icofont-ui-calendar"></i>
                    <br> الصباح و المساء </a>
                </li>
                <li>
                  <a href="#">
                    <i class="icofont-dashboard-web"></i>
                    <br> احصائيات </a>
                </li>
                <li>
                  <a href="#">
                    <i class="icofont-ui-laoding"></i>
                    <br> المسبحة </a>
                </li>
              </ul>
              <div class="tab_content">
                <div class="tabs_item">
                  <div class="row h-100 justify-content-center align-items-center">
                    <div class="col-lg-6 col-md-6">
                      <div class="tabs_item_content mt-0">
                        <h3>اذكاري</h3>
                        <p> خصص اذكارك و اذكاري سيذكرك بها يومياّ </p>
                        <ul>
                          <li>
                            <i class="icofont-ui-check"></i> يمكنك تحدد عدد مرات التذكير
                          </li>
                          <li>
                            <i class="icofont-ui-check"></i> يمكنك اضافة ما تشاء من اذكارك الخاصة
                          </li>
                          <li>
                            <i class="icofont-ui-check"></i> عند تثبيت التطبيق سياتي مع مجموعة اذكار يمكنك حذفها و
                            تعديلها لاحقاّ.
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="col-lg-6 col-md-6">
                      <div class="tabs_item_img">
                        <img :src="`${publicPath}assets/img/features-img1.png`" alt="img">
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tabs_item">
                  <div class="row h-100 justify-content-center align-items-center">
                    <div class="col-lg-6 col-md-6">
                      <div class="tabs_item_img">
                        <img :src="`${publicPath}assets/img/features-img1.png`" alt="img">
                      </div>
                    </div>
                    <div class="col-lg-6 col-md-6">
                      <div class="tabs_item_content mb-0">
                        <h3>رسائل أذكاري</h3>
                        <p></p>
                        <ul>
                          <li>
                            <i class="icofont-ui-check"></i> رسائل اذكاري المتجددة دائماّ
                          </li>
                          <li>
                            <i class="icofont-ui-check"></i> يمكنك ترتيب الرسائل حسب الموضوع
                          </li>
                          <li>
                            <i class="icofont-ui-check"></i> انواع الرسائل: ذكر, دعاء, اية, حديث, رسائلة, تحديث
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tabs_item">
                  <div class="row h-100 justify-content-center align-items-center">
                    <div class="col-lg-6 col-md-6">
                      <div class="tabs_item_content mt-0">
                        <h3>اذكار المسلم</h3>
                        <p> لجعل الذكر عادة, احيانا قد تحتاج الى محفز. وهذه الميزة صممت لتساعدك على جعل الذكر عادة. </p>
                        <ul>
                          <li>
                            <i class="icofont-ui-check"></i> تذكير بأذكار الصباح و المساء و النوم
                          </li>
                          <li>
                            <i class="icofont-ui-check"></i> يحتوي على اذكار الصلاة, السفر, دعاء الاستخارة و المزيد...
                          </li>
                          <li>
                            <i class="icofont-ui-check"></i> صممت الصفحة لتسهل عليك قراءة الاذكار
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="col-lg-6 col-md-6">
                      <div class="tabs_item_img">
                        <img :src="`${publicPath}assets/img/features-img1.png`" alt="img">
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tabs_item">
                  <div class="row h-100 justify-content-center align-items-center">
                    <div class="col-lg-6 col-md-6">
                      <div class="tabs_item_img">
                        <img :src="`${publicPath}assets/img/features-img1.png`" alt="img">
                      </div>
                    </div>
                    <div class="col-lg-6 col-md-6">
                      <div class="tabs_item_content mb-0">
                        <h3>احصائيات</h3>
                        <p> يمكنك متابعة الكثير من الاحصائيات لتقييم نفسك او لمعرفة ما قمت به. من هذه الاحصائيات: </p>
                        <ul>
                          <li>
                            <i class="icofont-ui-check"></i> الوقت الذي قضيته في صفحة الاذكار
                          </li>
                          <li>
                            <i class="icofont-ui-check"></i> عدد الاذكار التي ذكرتهات في التطبيق
                          </li>
                          <li>
                            <i class="icofont-ui-check"></i> عدد المشاركات التي شاركتها في صفحة ادعو معي
                          </li>
                          <li>
                            <i class="icofont-ui-check"></i> عدد الناس الذين تفاعلو مع ادعيتك
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tabs_item">
                  <div class="row h-100 justify-content-center align-items-center">
                    <div class="col-lg-6 col-md-6">
                      <div class="tabs_item_content mt-0">
                        <h3>المسبحة الاكترونية</h3>
                        <p> كل ما يسهل عليك الذكر ستجده في تطبيق اذكاري. لهذا تمت اضافة المسبحة الاكترونية الذكية. </p>
                        <ul>
                          <li>
                            <i class="icofont-ui-check"></i> يمكنك اضافة اذكارك الخاصة للمسبحة
                          </li>
                          <li>
                            <i class="icofont-ui-check"></i> ستحسب عدد مرات الذكر
                          </li>
                          <li>
                            <i class="icofont-ui-check"></i> ستتذكر مكان توقفك بالورد اليومي
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div class="col-lg-6 col-md-6">
                      <div class="tabs_item_img">
                        <img :src="`${publicPath}assets/img/features-img1.png`" alt="img">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="shape1">
        <img :src="`${publicPath}assets/img/shape1.png`" alt="img">
      </div>
      <div class="shape2">
        <img :src="`${publicPath}assets/img/shape2.png`" alt="img">
      </div>
      <div class="shape3">
        <img :src="`${publicPath}assets/img/shape3.png`" alt="img">
      </div>
      <div class="shape6">
        <img :src="`${publicPath}assets/img/shape6.png`" alt="img">
      </div>
      <div class="shape8 rotateme">
        <img :src="`${publicPath}assets/img/shape8.svg`" alt="shape">
      </div>
    </section>
    <!-- End SAAS Tools Area -->
    <!-- Start Screenshot Area -->
    <section class="screenshot-area ptb-100">
      <div class="container">
        <div class="section-title">
          <h2>صور من التطبيق</h2>
          <div class="bar"></div>
          <p> ملاحظة: قد تختلف الصور عن التطبيق نظرا للتحديث و التطوير المستمر للتطبيق </p>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <div class="screenshot-contain">
              <img :src="`${publicPath}assets/img/mobile.png`" class="mobile-light" alt="mobile">
              <div class="row">
                <div class="screenshot-slides">
                  <div class="col-lg-12">
                    <div class="screenshot-item">
                      <img :src="`${publicPath}assets/img/screenshot-img1.png`" alt="screenshot">
                    </div>
                  </div>
                  <div class="col-lg-12">
                    <div class="screenshot-item">
                      <img :src="`${publicPath}assets/img/screenshot-img4.png`" alt="screenshot">
                    </div>
                  </div>
                  <div class="col-lg-12">
                    <div class="screenshot-item">
                      <img :src="`${publicPath}assets/img/screenshot-img2.png`" alt="screenshot">
                    </div>
                  </div>
                  <div class="col-lg-12">
                    <div class="screenshot-item">
                      <img :src="`${publicPath}assets/img/screenshot-img3.png`" alt="screenshot">
                    </div>
                  </div>
                  <div class="col-lg-12">
                    <div class="screenshot-item">
                      <img :src="`${publicPath}assets/img/screenshot-img4.png`" alt="screenshot">
                    </div>
                  </div>
                  <div class="col-lg-12">
                    <div class="screenshot-item">
                      <img :src="`${publicPath}assets/img/screenshot-img1.png`" alt="screenshot">
                    </div>
                  </div>
                  <div class="col-lg-12">
                    <div class="screenshot-item">
                      <img :src="`${publicPath}assets/img/screenshot-img2.png`" alt="screenshot">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End Screenshot Area -->
    <!-- Start Team Area -->
    <!-- <section class="team-area ptb-100 bg-gray"><div class="container"><div class="section-title"><h2>Our Smart Team</h2><div class="bar"></div><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p></div><div class="row"><div class="team-slides"><div class="col-lg-12"><div class="single-team-member"><img :src="`${publicPath}assets/img/team-img1.jpg" alt="team"><div class="team-content"><h3>John Doe</h3><span>CEO</span><ul><li><a href="#"><i class="icofont-facebook"></i></a></li><li><a href="#"><i class="icofont-instagram"></i></a></li><li><a href="#"><i class="icofont-twitter"></i></a></li><li><a href="#"><i class="icofont-linkedin"></i></a></li></ul></div></div></div><div class="col-lg-12"><div class="single-team-member"><img :src="`${publicPath}assets/img/team-img2.jpg" alt="team"><div class="team-content"><h3>Steven Smith</h3><span>Developer</span><ul><li><a href="#"><i class="icofont-facebook"></i></a></li><li><a href="#"><i class="icofont-instagram"></i></a></li><li><a href="#"><i class="icofont-twitter"></i></a></li><li><a href="#"><i class="icofont-linkedin"></i></a></li></ul></div></div></div><div class="col-lg-12"><div class="single-team-member"><img :src="`${publicPath}assets/img/team-img3.jpg" alt="team"><div class="team-content"><h3>David Luiz</h3><span>Designer</span><ul><li><a href="#"><i class="icofont-facebook"></i></a></li><li><a href="#"><i class="icofont-instagram"></i></a></li><li><a href="#"><i class="icofont-twitter"></i></a></li><li><a href="#"><i class="icofont-linkedin"></i></a></li></ul></div></div></div><div class="col-lg-12"><div class="single-team-member"><img :src="`${publicPath}assets/img/team-img4.jpg" alt="team"><div class="team-content"><h3>Park Tim</h3><span>SEO Expert</span><ul><li><a href="#"><i class="icofont-facebook"></i></a></li><li><a href="#"><i class="icofont-instagram"></i></a></li><li><a href="#"><i class="icofont-twitter"></i></a></li><li><a href="#"><i class="icofont-linkedin"></i></a></li></ul></div></div></div><div class="col-lg-12"><div class="single-team-member"><img :src="`${publicPath}assets/img/team-img5.jpg" alt="team"><div class="team-content"><h3>Doglas Costa</h3><span>Manager</span><ul><li><a href="#"><i class="icofont-facebook"></i></a></li><li><a href="#"><i class="icofont-instagram"></i></a></li><li><a href="#"><i class="icofont-twitter"></i></a></li><li><a href="#"><i class="icofont-linkedin"></i></a></li></ul></div></div></div></div></div></div></section> -->
    <!-- End Team Area -->
    <!-- Start Pricing Area -->
    <!-- <section class="pricing-area ptb-100"><div class="container"><div class="section-title"><h2>Easy Pricing Plans</h2><div class="bar"></div><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p></div><div class="row"><div class="col-lg-4 col-md-6"><div class="pricing-table"><div class="price-header"><h3 class="title">Personal</h3><div class="price"><span class="dollar">$</span>15<span class="month">/Mo</span></div></div><div class="price-body"><ul><li><b>Free</b> Security Service</li><li><b>1x</b> Security Service</li><li><b>Unlimited</b> Security Service</li><li><b>1x</b> Dashboard Access</li><li><b>3x</b> Job Listings</li><li><b>5x</b> invoices and quotes</li></ul></div><div class="price-footer"><a class="btn btn-primary" href="#">Get Started</a></div></div></div><div class="col-lg-4 col-md-6"><div class="pricing-table"><div class="price-header"><h3 class="title">Business</h3><div class="price"><span class="dollar">$</span>39<span class="month">/Mo</span></div></div><div class="price-body"><ul><li><b>Free</b> Security Service</li><li><b>1x</b> Security Service</li><li><b>Unlimited</b> Security Service</li><li><b>1x</b> Dashboard Access</li><li><b>3x</b> Job Listings</li><li><b>5x</b> invoices and quotes</li></ul></div><div class="price-footer"><a class="btn btn-primary" href="#">Get Started</a></div></div></div><div class="col-lg-4 col-md-6 offset-lg-0 offset-md-3"><div class="pricing-table"><div class="price-header"><h3 class="title">Enterprise</h3><div class="price"><span class="dollar">$</span>99<span class="month">/Mo</span></div></div><div class="price-body"><ul><li><b>Free</b> Security Service</li><li><b>1x</b> Security Service</li><li><b>Unlimited</b> Security Service</li><li><b>1x</b> Dashboard Access</li><li><b>3x</b> Job Listings</li><li><b>5x</b> invoices and quotes</li></ul></div><div class="price-footer"><a class="btn btn-primary" href="#">Get Started</a></div></div></div></div></div><canvas id="canvas"></canvas></section> -->
    <!-- End Pricing Area -->
    <!-- Start App Download Area -->
    <section class="app-download ptb-100 bg-gray">
      <div class="container">
        <div class="row h-100 justify-content-center align-items-center">
          <div class="col-lg-6 col-md-12">
            <div class="section-title">
              <h2>حمل تطبيق أذكاري الان</h2>
              <div class="bar"></div>
              <p> الطريقة الافضل لتذكيرك بالاذكار هي الطريقة التي لا تتوقعها... لذا دع اذكاري يذكرك </p>
              <div class="download-btn">
                <a href="http://bit.ly/2Yh5hHn" target="_blank">
                  <i class="icofont-brand-android-robot"></i> متوفر على <span>جوجل اندرويد</span>
                </a>
                <a href="https://apple.co/34Rcosr" target="_blank">
                  <i class="icofont-brand-apple"></i> متوفر على <span>ايفون و ايباد</span>
                </a>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-12">
            <div class="download-image">
              <img :src="`${publicPath}assets/img/frame3_qibla.png`" alt="image">
              <img :src="`${publicPath}assets/img/frame5_halka.png`" alt="image">
              <!-- <img :src="`${publicPath}assets/img/features-img1.png" alt="image"> -->
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- End App Download Area -->
    <!-- Start Blog Area -->
    <!-- <section class="blog-area ptb-100"><div class="container"><div class="section-title"><h2>Our Latest News</h2><div class="bar"></div><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p></div><div class="row"><div class="blog-slides"><div class="col-lg-12 col-md-12"><div class="single-blog-post"><a href="#" class="post-image"><img :src="`${publicPath}assets/img/blog-img1.jpg" alt="blog-image"></a><div class="blog-post-content"><ul><li><i class="icofont-user-male"></i><a href="#">Admin</a></li><li><i class="icofont-wall-clock"></i> January 23, 2019</li></ul><h3><a href="#">The Most Popular New Business Apps</a></h3><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi turpis massa, dapibus nec libero vitae.</p><a href="#" class="read-more-btn">Read More <i class="icofont-rounded-double-right"></i></a></div></div></div><div class="col-lg-12 col-md-12"><div class="single-blog-post"><a href="#" class="post-image"><img :src="`${publicPath}assets/img/blog-img2.jpg" alt="blog-image"></a><div class="blog-post-content"><ul><li><i class="icofont-user-male"></i><a href="#">Admin</a></li><li><i class="icofont-wall-clock"></i> January 16, 2019</li></ul><h3><a href="#">The Best Marketing Management Tools</a></h3><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi turpis massa, dapibus nec libero vitae.</p><a href="#" class="read-more-btn">Read More <i class="icofont-rounded-double-right"></i></a></div></div></div><div class="col-lg-12 col-md-12"><div class="single-blog-post"><a href="#" class="post-image"><img :src="`${publicPath}assets/img/blog-img3.jpg" alt="blog-image"></a><div class="blog-post-content"><ul><li><i class="icofont-user-male"></i><a href="#">Admin</a></li><li><i class="icofont-wall-clock"></i> January 14, 2019</li></ul><h3><a href="#">3 WooCommerce Plugins to Boost Sales</a></h3><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi turpis massa, dapibus nec libero vitae.</p><a href="#" class="read-more-btn">Read More <i class="icofont-rounded-double-right"></i></a></div></div></div><div class="col-lg-12 col-md-12"><div class="single-blog-post"><a href="#" class="post-image"><img :src="`${publicPath}assets/img/blog-img4.jpg" alt="blog-image"></a><div class="blog-post-content"><ul><li><i class="icofont-user-male"></i><a href="#">Admin</a></li><li><i class="icofont-wall-clock"></i> January 06, 2019</li></ul><h3><a href="#">CakeMail Review – Design Custom Emails</a></h3><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi turpis massa, dapibus nec libero vitae.</p><a href="#" class="read-more-btn">Read More <i class="icofont-rounded-double-right"></i></a></div></div></div><div class="col-lg-12 col-md-12"><div class="single-blog-post"><a href="#" class="post-image"><img :src="`${publicPath}assets/img/blog-img5.jpg" alt="blog-image"></a><div class="blog-post-content"><ul><li><i class="icofont-user-male"></i><a href="#">Admin</a></li><li><i class="icofont-wall-clock"></i> January 04, 2019</li></ul><h3><a href="#">The Most Popular New Apps in 2019</a></h3><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi turpis massa, dapibus nec libero vitae.</p><a href="#" class="read-more-btn">Read More <i class="icofont-rounded-double-right"></i></a></div></div></div><div class="col-lg-12 col-md-12"><div class="single-blog-post"><a href="#" class="post-image"><img :src="`${publicPath}assets/img/blog-img3.jpg" alt="blog-image"></a><div class="blog-post-content"><ul><li><i class="icofont-user-male"></i><a href="#">Admin</a></li><li><i class="icofont-wall-clock"></i> January 26, 2019</li></ul><h3><a href="#">The Fastest Growing Apps in 2019</a></h3><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Morbi turpis massa, dapibus nec libero vitae.</p><a href="#" class="read-more-btn">Read More <i class="icofont-rounded-double-right"></i></a></div></div></div></div></div></div></section> -->
    <!-- End Blog Area -->
    <!-- Start Feedback Area -->
    <!-- <section class="feedback-area ptb-100 bg-gray"><div class="container"><div class="section-title"><h2>Testimonials</h2><div class="bar"></div><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p></div><div class="row"><div class="feedback-slides"><div class="col-lg-12"><div class="single-feedback"><div class="client-info"><img :src="`${publicPath}assets/img/client1.jpg" alt="client"><h3>Alit John</h3><span>Web Developer</span></div><p>Plan ahead by day, week, or month, and see project status at a glance. Search and filter to focus in on anything form a single project individual.</p></div></div><div class="col-lg-12"><div class="single-feedback"><div class="client-info"><img :src="`${publicPath}assets/img/client2.jpg" alt="client"><h3>Alit John</h3><span>SEO Expert</span></div><p>Plan ahead by day, week, or month, and see project status at a glance. Search and filter to focus in on anything form a single project individual.</p></div></div><div class="col-lg-12"><div class="single-feedback"><div class="client-info"><img :src="`${publicPath}assets/img/client3.jpg" alt="client"><h3>Steven John</h3><span>Web Developer</span></div><p>Plan ahead by day, week, or month, and see project status at a glance. Search and filter to focus in on anything form a single project individual.</p></div></div><div class="col-lg-12"><div class="single-feedback"><div class="client-info"><img :src="`${publicPath}assets/img/client4.jpg" alt="client"><h3>David Warner</h3><span>Web Developer</span></div><p>Plan ahead by day, week, or month, and see project status at a glance. Search and filter to focus in on anything form a single project individual.</p></div></div></div></div></div><svg class="svg-feedback-bottom"
																																																																					xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="none"><path d="M0,70 C30,130 70,50 100,70 L100,100 0,100 Z" fill="#ffffff"/></svg></section> -->
    <!-- End Feedback Area -->
    <!-- Start Subscribe Area -->
    <section class="subscribe-area ptb-100">
      <div class="container">
        <div class="section-title">
          <h2>اتصل بنا</h2>
          <div class="bar"></div>
          <p> يمكنكم ارسال اقتراحاتكم و التواصل معنا من هنا </p>
        </div>
        <a href="mailto:athkariii01@gmail.com" class="btn btn-primary">راسلنا</a>
        <!-- <form class="newsletter-form" data-toggle="validator"><input type="email" class="form-control" placeholder="Enter your email address" name="EMAIL" required autocomplete="off"><button class="btn btn-primary" type="submit">Subscribe</button><div id="validator-newsletter" class="form-result"></div></form> -->
      </div>
    </section>
    <!-- End Subscribe Area -->
  </div>
</template>

<script>
import 'script-loader!owl.carousel'

export default {
  name: "Home",
  data() {
    return {
      publicPath: process.env.BASE_URL,
    };
  },
  mounted() {
    let owl = window.$(".screenshot-slides");
    owl.owlCarousel({
      loop: true,
      nav: true,
      rtl: true,
      autoplay: true,
      autoplayHoverPause: true,
      mouseDrag: true,
      center: true,
      dots: false,
      navText: [
        "<i class='icofont-bubble-left'></i>",
        "<i class='icofont-bubble-right'></i>"
      ],
      responsive: {
        0: {
          items: 1,
        },
        768: {
          items: 2,
        },
        1024: {
          items: 3,
        },
        1200: {
          items: 3,
        }
      }
    });
  },
}
</script>
<style scoped>
.owl-theme .owl-nav {
  margin-top: 135px;
}

.owl-theme .owl-nav [class*=owl-] {
  color: #ff8a73;
  font-size: 30px;
  margin: 0 3px;
  padding: 0;
  background: transparent;
  display: inline-block;
  cursor: pointer;
  border-radius: 0;
  transition: 0.4s;
}

.owl-theme .owl-nav [class*=owl-]:hover {
  color: #13c4a1;
}

.owl-theme .owl-controls {
  line-height: 0.1;
}

</style>
